import { useTranslation } from "react-i18next";
import TaskIcon from "../../../icons/taskIcon";

const CustomClearanceTool = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <TaskIcon className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("customClearance")}
          </h1>
          <p className="mx-auto my-10 text-lg text-center text-mainGray">
            {t("customsTariffsAreImposedByCountries")}
          </p>
          <section className="space-y-8">
            <h2 className="text-xl font-bold text-center text-mainRed ">
              {t("customsClearanceSteps")}
            </h2>
            <p>
              <span className="text-mainRed">{t("documentation")}</span>
              {t("youNeedToProvideDocuments")}
            </p>
            <p>
              <span className="text-mainRed">{t("customsDeclaration")}</span>
              {t("declareTheGoodsCustoms")}
            </p>
            <p>
              <span className="text-mainRed">{t("PaymentOfTaxes")}</span>
              {t("customsWillCalDuties")}
            </p>
            <p>
              <span className="text-mainRed">{t("inspection")}</span>
              {t("customsMayInspec")}
            </p>
            <h3 className="!-mb-8 text-mainRed">{t("whyCustomsImportant")}</h3>
            <p>{t("ensuresTheGoodsMeet")}</p>
            <p>
              <span className="text-mainRed">{t("avoidDelays")}</span>
              {t("properCustomsClearance")}
            </p>
            <p>
              <span className="text-mainRed">{t("protection")}</span>
              {t("protectsThrEconomy")}
            </p>
          </section>
          <h3 className="text-[20px] text-mainRed font-bold my-2">{t("conclusion")}</h3>
          <p>{t("customsClearanceIsVital")}</p>
        </div>
      </article>
    </main>
  );
};

export default CustomClearanceTool;
